<template>
  <div class="card card-pad-lg h-100">
    <div style="display:flex; justify-content:space-between; align-items:center;">
      <div class="section-title">Top Platos por Unidades e Ingresos</div>
      <div class="tabs">
        <button class="tab" :class="{active:mode==='units'}" @click="$emit('update:mode','units')">Por Unidades</button>
        <button class="tab" :class="{active:mode==='revenue'}" @click="$emit('update:mode','revenue')">Por Ingresos</button>
      </div>
    </div>

    <div style="overflow-x: auto; width:100%">
      <table class="table" style="margin-top:14px; border-collapse: collapse;">
        <thead>
          <tr>
            <th style="width:56px;">#</th>
            <th>Plato</th>
            <th style="width:120px;">Unidades</th>
            <th style="width:120px;">Precio</th>
            <th style="width:140px;">Ingresos</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(p,idx) in rows" :key="p.id">
            <td><span class="badge text-black">{{ '#'+(idx+1) }}</span></td>
            <td>{{ p.name }}</td>
            <td>{{ p.units }}</td>
            <td>{{ Number(p.price||0).toFixed(2) }}€</td>
            <td><b>{{ Number(p.revenue||0).toFixed(2) }}€</b></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default{
  name:'TopDishesTable',
  props:{
    mode:{ type:String, default:'units' },
    rows:{ type:Array, default:()=>[] }
  }
}
</script>
